import { Component, Vue } from 'vue-property-decorator'
import { TABS } from '../constants'
import Pager from '../components/pager'
import Question from '../components/question'
import EmptyBox from '../components/empty-box'
import { getFavoriteList, getCollectList } from '../model/api'

@Component({ components: { Pager, Question, EmptyBox } })
export default class H5List extends Vue {
    public tabs: any[] = TABS
    public defaultTab: any = {
        value: '2',
        label: '试题'
    }
    public questionList: any[] = []
    public paperList: any[] = []
    public page: number = 1
    public pageOfPaper: number = 1
    public total: number = 0
    public totalOfPaper: number = 0
    public perPage: number = 10

    public get token() {
        const { token } = this.$route.query
        return token
    }

    public handleSelectTab(item) {
        this.defaultTab = item
        const { label, value } = item
        let page = 1
        if (value === '1') {
            this.getPaperList(page)
        } else {
            this.getQuestionList(page)
        }
    }
    public async getQuestionList(page) {
        this.page = page
        const { data, success }: any = await getCollectList({
            page,
            category: 2
        }, {
            token: this.token
        })
        if (success) {
            const { records, total } = data
            this.questionList = records
            this.total = total
        }
    }

    public async getPaperList(page) {
        this.pageOfPaper = page
        const { data, success }: any = await getCollectList({
            page,
            category: 1
        }, {
            token: this.token
        })
        if (success) {
            const { records, total } = data
            this.paperList = records
            this.totalOfPaper = total
        }
    }

    public handlePrev(page) {
        let prev = page - 1
        this.getQuestionList(prev)
    }

    public handleNext(page) {
        let next = page + 1
        this.getQuestionList(next)
    }

    public handlePrevPaper(page) {
        let prev = page - 1
        this.getPaperList(prev)
    }

    public handleNextPaper(page) {
        let next = page + 1
        this.getPaperList(next)
    }
    // 点击跳转试卷详情
    public handleClkPaper(item) {
        const uni = (window as any).uni
        const { paper } = item
        const { subject_id, paper_id, name } = paper
        uni.navigateTo({
            url: `/pages/common/paper-detail/paper-detail?id=${paper_id}&subject=${subject_id}&name=${encodeURIComponent(name)}`
        })
    }

    public mounted() {
        // 默认为题目列表页面
        this.getQuestionList(1)
    }
}